<template>
  <div>
    <div v-if="dropownLoader">
      <Loader />
    </div>

    <div v-else>
      <div class="datepickerwrap card tw-border-0">
        <div class="tw-flex tw-justify-between tw-items-center">
          <div id="werehouseDateRange" class="tw-flex tw-gap-6">
            <div>
              <div class="tw-text-[#050A13] tw-text-[14px] tw-mb-3 tw-mx-1">
                Date
              </div>
              <date-range-picker
                v-model="dateRange"
                :show-dropdowns="true"
                opens="right"
                :autoApply="true"
                :single-date-picker="true"
                :locale-data="{ format: 'dd mmm yyyy' }"
                :max-date="maxDate"
                @update="dataAPIs"
              >
              </date-range-picker>
            </div>
            <div class="customMultiselectCommon" style="margin-top: -1px">
              <div class="tw-text-[#050A13] tw-text-[14px] tw-mb-3 tw-mx-1">
                Warehouse
              </div>
              <multiselect
                v-model="selectedWarehouse"
                :options="warehouseList"
                :multiple="false"
                :searchable="false"
                placeholder="Select Warehouse"
                label="warehouse_name"
                track-by="warehouse_name"
                class="tw-w-[215px]"
                :showLabels="false"
                :close-on-select="true"
                :allow-empty="false"
                @select="dataAPIs"
              >
              </multiselect>
            </div>
            <div class="customMultiselectCommon" style="margin-top: -1px">
              <div class="tw-text-[#050A13] tw-text-[14px] tw-mb-3 tw-mx-1">
                Channel
              </div>

              <multiselect
                v-model="selectedChannel"
                :options="channelList"
                :multiple="false"
                :searchable="true"
                placeholder="Select Channel"
                label="product_sku"
                track-by="product_sku"
                class="tw-w-[215px]"
                :showLabels="false"
                :close-on-select="true"
                :allow-empty="false"
                @select="dataAPIs"
              >
              </multiselect>
            </div>
            <div class="customMultiselectCommon" style="margin-top: -1px">
              <div class="tw-text-[#050A13] tw-text-[14px] tw-mb-3 tw-mx-1">
                SKU
              </div>
              <multiselect
                v-model="selectedSKU"
                :options="skuList"
                :multiple="false"
                :searchable="true"
                placeholder="Enter SKU ID"
                label="product_sku"
                track-by="product_sku"
                class="tw-w-[215px]"
                :showLabels="false"
                :close-on-select="true"
                :allow-empty="false"
                @select="dataAPIs"
              >
              </multiselect>
            </div>
          </div>
          <div class="tw-flex tw-items-center tw-gap-10">
            <div
              @click="handleDownloadTemplate"
              class="tw-text-primary_brand tw-text-base tw-font-bold tw-cursor-pointer"
            >
              Download Template
            </div>
            <input
              :disabled="uploadFileLoader"
              type="file"
              class="d-none"
              accept=".xlsx"
              id="row.platform_id + '_file'"
              @change="uploadSKUData($event)"
              onclick="this.value = null"
            />
            <label for="row.platform_id + '_file'" class="tw-mb-0">
              <div
                class="btn primarycolor tw-bg-primary_brand tw-text-[#fff] tw-text-base tw-font-bold"
              >
                {{ uploadFileLoader ? "Uploading..." : "Upload" }}
              </div>
            </label>
          </div>
        </div>
      </div>
      <!-- <div class="datepickerwrap card tw-border-0 summaryContainer row tw-z-[10] tw-grid tw-grid-cols-5 tw-gap-5" v-if="Object.keys(summaryData).length">
            <div  v-for="(card,idx) of summaryMetricData" :key="idx"  >
                <div class="tw-border-[1px] tw-border-[#D4D4D4] tw-rounded-[5px] tw-p-4">
                    <img :src="'Icons_SVG/'+card.name+'.svg'" style="border:1px solid" class="tw-border-[#D4D4D4] tw-mb-4 tw-p-2 tw-rounded-[5px]"/>
                    <div class="tw-text-[14px] tw-text-[##5E5E5E]">{{card.name}}</div>
                    <div class="tw-flex tw-justify-between tw-items-center">
                        <div class="tw-mt-2 tw-text-[24px] tw-text-[#000] tw-text-bold ">{{card?.value.count}}</div>
                        <div v-show="card?.value.percentage_type!='neutral'">
                            <div class=" tw-flex tw-items-center tw-bg-[#DCFCE7] tw-p-2 tw-px-4 tw-rounded-[5px]  tw-text-[#15803D]" v-if="card?.value.percentage_type=='positive'" >
                               <img src="Icons_SVG/upArrow.svg" class="tw-mr-2"/> <span class="text-font-semibold">{{card?.value?.percentage}}%</span>
                            </div>
                            <div class=" tw-flex tw-items-center tw-bg-[#FEE2E2] tw-p-2 tw-px-4 tw-rounded-[5px] tw-text-[##B91C1C]" v-if="card?.value.percentage_type=='negative'">
                                <img src="Icons_SVG/downArrow.svg" class="tw-mr-2"/> <span class="text-font-semibold">{{card?.value?.percentage}}%</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
      <div
        v-if="Object.keys(summaryData).length"
        class="datepickerwrap card tw-border-0 summaryContainer row tw-z-[10]"
      >
        <div>
          <div
            class="tw-flex tw-justify-between tw-pb-2 tw-mb-4 tw-border-b-[1px] tw-border-[#D4D4D4]"
          >
            <span
              class="tw-text-[16px] tw-text-[#065559] tw-font-[600] tw-pb-1 tw-mb-2"
              >Warehouse Summary
            </span>
            <button class="btn primarycolor" @click="handleDownloadTable">
              Export
            </button>
          </div>
        </div>
        <table id="summaryDataTable" class="tw-w-full">
          <thead>
            <tr>
              <th v-for="(item, index) in summaryData.header" :key="index">
                <span>{{ item.label }}</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, idx) in summaryData.data" :key="idx">
              <td v-for="(head, index) in summaryData.header" :key="index">
                {{ item[head.key] }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else class="summaryContainer row datepickerwrap card">
        <div v-if="summaryTableLoader" class="onLoadingData mt-3">
          Loading...
        </div>
        <div
          v-else
          class="text-danger d-flex justify-content-center border border-danger rounded mt-3 noData"
        >
          No Data!
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import Multiselect from "vue-multiselect";
import Loader from "../Components/Loader.vue";
export default {
  name: "wareHouseSummary",
  components: { Datepicker, Multiselect, Loader },
  data: function () {
    return {
      dropownLoader: false,
      step: 1,
      skuInput: "",
      suggestions: [],
      selectedWarehouse: "",
      warehouseList: [],
      selectedSKU: "",
      skuList: [],
      selectedChannel: "",
      channelList: [],
      selecetdQuantity: "",
      selectedTowards: "",
      summaryData: [],
      dateRange: {
        startDate: moment().format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      maxDate: new Date(),
      activeTab: 0,
      summaryTableLoader: false,
      summaryMetricData: "",
      uploadFileLoader: false,
    };
  },
  mounted() {
    this.getDropdownData();
  },

  methods: {
    dataAPIs() {
      if ($.fn.DataTable.isDataTable("#summaryDataTable")) {
        $("#summaryDataTable").DataTable().destroy();
      }
      this.getMetricData();
      this.getTableData();
    },
    getDropdownData() {
      this.dropownLoader = true;
      const url = "/api/v3/of/inventory";

      this.$http
        .get(url)
        .then((response) => {
          this.warehouseList = response.data.data.warehouse;
          this.selectedWarehouse = this.warehouseList[0];
          this.skuList = response.data.data.sku;
          this.selectedSKU = this.skuList[0];
          this.channelList = response.data.data.channel;
          this.selectedChannel = this.channelList[0];
          this.dropownLoader = false;
          this.dataAPIs();
        })
        .catch((error) => {
          this.dropownLoader = false;
          console.error("Error fetching warehouse data:", error);
        });
    },

    getMetricData() {
      this.summaryMetricData = "";
      const url = "/api/v3/of/summary";
      const payload = {
        warehouse_id: this.selectedWarehouse?.warehouse,
        timestamp: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        product_sku: this.selectedSKU?.product_sku,
      };
      this.$http
        .post(url, payload)
        .then((response) => {
          this.summaryMetricData = response.data.data;
        })
        .catch((error) => {
          console.error("Error fetching table data:", error);
        });
    },
    getTableData() {
      this.summaryData = "";
      this.summaryTableLoader = true;
      const url = "/api/v3/of/table";
      const payload = {
        warehouse_id: this.selectedWarehouse?.warehouse,
        timestamp: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        product_sku: this.selectedSKU?.product_sku,
      };
      this.$http
        .post(url, payload)
        .then((response) => {
          this.summaryData = response.data.data;
          this.summaryTableLoader = false;
          this.$nextTick(() => {
            this.processTable("#summaryDataTable");
          });
        })
        .catch((error) => {
          this.summaryTableLoader = false;
          console.error("Error fetching table data:", error);
        });
    },

    handleDownloadTemplate() {
      const url = `/api/v3/of/excel?warehouse_name=${this.selectedWarehouse.warehouse_name}&warehouse_id=${this.selectedWarehouse.warehouse}&warehouse_alias=${this.selectedWarehouse.warehouse_alias}`;
      this.$http
        .get(url)
        .then((res) => {
          window.location.href = res.data.data.data;
        })
        .catch((error) => {
          console.error("Error downloading template:", error);
        });
    },

    uploadSKUData(e) {
      this.uploadFileLoader = true;
      const url = "/api/v3/of/excel";
      const formData = new FormData();
      formData.append("file", e.target.files[0]);
      formData.append("warehouse_name", this.selectedWarehouse.warehouse_name);
      formData.append("warehouse_id", this.selectedWarehouse.warehouse);
      formData.append(
        "warehouse_alias",
        this.selectedWarehouse.warehouse_alias
      );
      this.$http
        .post(url, formData)
        .then((res) => {
          this.uploadFileLoader = false;
          this.$bvToast.toast(`Uploaded`, {
            title: "Weavr Sense",
            variant: "success",
            toaster: "b-toaster-top-center",
            autoHideDelay: 3000,
          });
        })
        .catch((error) => {
          this.uploadFileLoader = false;
          this.$bvToast.toast(`Technical Error!`, {
            title: "Weavr Sense",
            variant: "danger",
            toaster: "b-toaster-top-center",
            autoHideDelay: 3000,
          });
          console.error("Error saving form:", error);
        });
    },
    handleDownloadTable() {
      this.dropownLoader = true;
    
      const url = "/api/v3/of/table";
      const payload = {
        warehouse_id: this.selectedWarehouse.warehouse,
        timestamp: this.dateRange.endDate,
        product_sku: this.selectedSKU.product_sku,
        download: true,
      };

      this.$http
        .post(url, payload)
        .then((res) => {
          window.location = res.data.data.file_url;
         this.dataAPIs();
          this.dropownLoader = false;
        })
        .catch((err) => {
          console.error(err);
          this.dropownLoader = false;
        });
    },
    processTable(id) {
      $(id).DataTable().destroy();
      $(id).DataTable({
        searching: true,
        info: true,
        ordering: true,
        order: [],
        columnDefs: [
          {
            targets: 0,
            className: "min-width-column",
          },
        ],
        initComplete: function () {
          $(id).wrap(
            "<div style='overflow:auto; width:100%;position:relative;'></div>"
          );
        },
        language: {
          search: "",
          searchPlaceholder: "Search...",
          paginate: {
            first: "",
            previous: "<",
            next: ">",
            last: "",
          },
          lengthMenu: "<h5>Show entries</h5> _MENU_",
        },
      });
      $(id + "_filter > label").append(
        `<div class='search_icon'><img src='/Icons_SVG/Search.svg' width='20' /></div>`
      );
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.stepper-container {
  padding: 20px;
  font-family: sans-serif;
}
.steps {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.step {
  font-weight: 600;
  color: #999;
}
.step.active {
  color: #065559;
  font-weight: bold;
}
.step-circle.active {
  background-color: #065559;
  color: white;
  padding: 10px;
  border-radius: 50%;
}
.line {
  flex-grow: 1;
  height: 2px;
  background-color: #ccc;
  margin: 0 10px;
}
.input-box {
  width: 100%;
  padding: 10px;
  border: 1px solid #aeaeae;
  border-radius: 5px;
  margin-bottom: 16px;
}
.suggestions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.sku-pill {
  border: 1px solid #aeaeae;
  border-radius: 20px;
  padding: 6px 12px;
  background: white;
  cursor: pointer;
}
.button-group {
  text-align: right;
}
button.primarycolor {
  background: var(--primary_brand);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 5px 25px;
  border-radius: 6px;
  letter-spacing: 0.2px;
  font-weight: bold;
  font-size: 16px;
}

button.primarycolor:hover {
  color: white;
  background: var(--primary_brand-80);
}

.navigationButton {
  height: 35px;
  border: none;
  margin: 0;
  background: var(--accent_color);
  color: white;
  border-radius: 5px;
  font-size: 16px;
  font-weight: bold;
  padding: 0px 20px;
  letter-spacing: 0.2px;
  font-family: "poppins";
}

.navigationButton:hover {
  background: var(--accent_color-80);
}
</style>
<style>
#werehouseDateRange .multiselect__tags {
  border: 1px solid #ccc !important;
  max-height: 20px !important;
}
#werehouseDateRange .reportrange-text {
  height: 34px !important;
  width: 180px !important;
}
#werehouseDateRange .reportrange-text span {
  font-size: 16px !important;
}
</style>
